<template>
	<section class="newsletter-section">
		<div class="row">
			<div class="columns column5">
				<h2>{{ header }}</h2>
				<div v-parse-links v-html="content" />
			</div>
			<div class="columns column7">
				<form class="newsletter">
					<input type="text" :placeholder="$t('formEmail')" />
					<input type="submit" class="button" :value="button" />
				</form>
			</div>
		</div>
	</section>
</template>

<script setup>
defineProps({
	header: { type: String, default: '' },
	content: { type: String, default: '' },
	button: { type: String, default: '' },
});
</script>

<style lang="scss" scoped>
.newsletter-section {
	padding: 75px 0;
	background: var(--secondary-background-color);
	color: var(--body-color);

	h2,
	div {
		color: #fff;
	}

	form {
		margin-top: 30px;

		input {
			background: var(--primary-background-color);
			padding: 15px;
			height: 52px;
			border: none;
			width: 48%;
			max-width: 300px;
			vertical-align: top;

			&::placeholder {
				color: #333;
			}

			&.button {
				line-height: 22px;
				background: var(--cta-color);
				color: #fff;
				max-width: 200px;

				&:hover {
					background: var(--cta-color-hover);
					color: #fff;
				}
			}
		}
	}
}
</style>
